import { useEffect, useState, useMemo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    Radio,
    RadioGroup
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { getRequest, postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';
import "./style.css";
import { DateTimePicker } from '@mui/x-date-pickers';
import { dateFormattertime } from 'src/services/fetching';


export const TestScheduleModal = ({ open, onClose, row }) => {
    console.log("🚀 ~ TestEmailModal ~ row:", row)
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);
    const [ value, setValue ] = useState(new Date());
    console.log("🚀 ~ TestScheduleModal ~ value:", value)
    const [ data, setData ] = useState();
    const [ selectedGroup, setSelectedGroup ] = useState("all_registered");

    const NewDocumentSchema = Yup.object().shape({
        // code: Yup.string().required('Name is required'),

    });

    const defaultValues = useMemo(
        () => ({

        }),
        []
    );
    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;


    useEffect(() => {
        reset(defaultValues);
    }, [ reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('scheduled_date_time', dateFormattertime(value));
        formData.append('send_to', selectedGroup);
        try {
            const response = await postRequest(
                `${endpoints.admin_dashboard.product_updates.newsletter.sedhle_email}/${row?.id}`,
                formData,
                true
            );
            if (response.metadata?.success) {
                reset();
                onClose();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });

    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="md"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
            scroll={ "body" }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Schedule Email  &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent >
                    <Box
                        mt={ 2 }
                        rowGap={ 2 }
                        gap={ 2 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(1, 1fr)',
                        } }
                    >
                        <DateTimePicker
                            label="DateTimePicker"
                            name="scheduled_date_time"
                            value={ value }
                            onChange={ setValue }
                            slotProps={ {
                                textField: {
                                    fullWidth: true,
                                },
                            } }
                        />
                    </Box>
                    <Box mt={ 2 } display="grid">
                        <RadioGroup
                            row
                            value={ selectedGroup }
                            onChange={ (e) => setSelectedGroup(e.target.value) }
                        >
                            <FormControlLabel value="all_registered" control={ <Radio size="medium" /> } label="All Registered Users" />
                            <FormControlLabel value="subscribed" control={ <Radio size="medium" /> } label="Subscribed Users" />
                            <FormControlLabel value="verified" control={ <Radio size="medium" /> } label="Verified Users" />
                            <FormControlLabel value="non_verified" control={ <Radio size="medium" /> } label="Non Verified Users" />
                            <FormControlLabel value="newsletter" control={ <Radio size="medium" /> } label="Newsletter Users" />
                        </RadioGroup>
                    </Box>


                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ onClose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting }
                    >
                        Submit
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog >
    );
};